import { render, staticRenderFns } from "./MiniBadge.vue?vue&type=template&id=b2f4fd18&scoped=true&"
import script from "./MiniBadge.vue?vue&type=script&lang=js&"
export * from "./MiniBadge.vue?vue&type=script&lang=js&"
import style0 from "./MiniBadge.vue?vue&type=style&index=0&id=b2f4fd18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f4fd18",
  null
  
)

export default component.exports